<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card class="bg-gray">
      <b-card>
        <b-row
          class=""
          align-v="center"
        >
          <b-col
            cols="12"
            md="6"
          >
            <b-form-input
              v-model="filter.search"
              :placeholder="$t('search')"
            />
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="mt-2 mt-md-0"
          >
            <b-form-checkbox
              v-model="filter.showWithBalance"
              name="check-button"
              switch
            >
              {{ $t('OnlyDisplayWalletsWithBalance') }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-card>
      <b-row
        v-if="cryptoWallets.length > 0"
        class="mt-5"
      >
        <b-col
          v-for="(item, index) in filtredWallets"
          :key="index"
          cols="12"
          md="6"
          xl="4"
        >
          <b-card
            class="rounded-lg "
            style="overflow:hidden;"
          >
            <b-row
              class="m-0"
            >
              <b-col
                class="d-flex align-items-center bg-gray p-2 rounded-sm"
              >
                <b-avatar :src="getCoinAvatar(item.token)" />
                <div class="coins mx-2 d-flex flex-column align-items-center">
                  <h6 class="m-0">
                    {{ (item.name ? item.name : item.name) }}
                  </h6>
                </div>
              </b-col>

            </b-row>
            <b-row>
              <b-col>
                <div
                  :class="$store.state.appConfig.layout.skin == 'dark' ? 'text-white' : ''"
                  class="h3 my-3 d-flex justify-content-between align-items-center"
                >
                  <h5>{{ $t('balance') }}</h5>
                  <div class="text-primary d-flex align-items-center">
                    <h5 class="text-primary">{{ item.quantity &&
                      helpers.numberWithCommas(helpers.toFixed(item.quantity, item.currency_network[0].exchange.quantity_decimal_for_wallet)) }}</h5>
                    <h5 class="mx-1 text-primary">
                      {{ item.token }}
                    </h5>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row
              class="d-flex m-0"
              align-h="center"
            >
              <b-col cols="6">
                <b-button
                  pill
                  class="d-flex justify-content-center align-items-center  customHover w-100"
                  :variant="item.depositable ? 'primary' : ''"
                  :disabled="!item.depositable"
                  :to="item.currency_network[0].is_fiat ? `/${$i18n.locale}/customer-wallets/deposit` : `/${$i18n.locale}/customer-wallets/crypto-deposit/${(item.token ? item.token : item.token).toLowerCase()}/${item.token.toLowerCase()}`"
                >
                  <span>{{ $t('crypto_wallet_deposit') }}</span>
                </b-button>
              </b-col>
              <b-col cols="6">
                <b-button
                  pill
                  class="d-flex justify-content-center align-items-center  customHover w-100"
                  :variant="item.withdrawable ? 'dark' : ''"
                  :disabled="!item.withdrawable"
                  :to="item.currency_network[0].is_fiat ? `/${$i18n.locale}/customer-wallets/withdraw` : `/${$i18n.locale}/customer-wallets/crypto-withdraw/${(item.token ? item.token : item.token).toLowerCase()}/${item.token.toLowerCase()}`"
                >
                  <span> {{ $t('crypto_wallet_withdrawal') }} </span>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>
<script>
import cryptoWalletsMixin from '@/modules/crypto/views/logic/customer-wallets/cryptoWallets'

export default {

  mixins: [cryptoWalletsMixin],
  data() {
    return {
      backgroundImg: '',
      backgroundColor: 'black',
    }
  },

}
</script>
<style scoped>

.custom-btn {
  font-size: 12px;
}

.createWallet {
  width: 4.3rem;
  transition: all .3s ease;
  display: flex;
  align-items: center;
}

.createWallet:hover {
  width: 100%;
}

.createSpan:nth-child(1) {
  transition: all .7s cubic-bezier(.23, -0.04, .77, -1.49)
}

.createSpan:nth-child(2) {
  visibility: hidden;
  transition: all .3s;
  white-space: nowrap;
}

.createWallet:hover .createSpan:nth-child(2) {
  visibility: visible;
}

.createWallet:hover .createSpan:nth-child(1) {
  transform: rotate(90deg);
}

/* .bubble{
  position: absolute;
  top:-1rem;
  right:-1rem;
  width: 14rem;
  height:14rem;
  border-radius: 50%;
  background: #fafbffdc !important;
} */

.customHover {
  transition: all .2s;
  backface-visibility: hidden;
}

/* .customHover:hover{
  transform: scale(1.1) translateZ(0);
} */

.createWalletBtn {
  width: 250px;
}

@media only screen and (max-width: 600px) {
  .createWalletBtn {
    width: 100%;
  }
}

.crypto-card {
  background-color: #ffb065;
  padding: 11px;
  border-radius: 4px;
  opacity: 90%;
}
</style>
